// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qna-form {
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    width: 70%;
    margin: 30px auto;
    align-items: center; /* Centers the form contents */
}

.form-group {
    display: flex;
    flex-direction: column; /* Stack label on top of input */
    align-items: flex-start;
    width: 100%;
    margin-bottom: 15px;
}

.form-group label {
    font-size: 16px;
    font-weight: light;
    margin-bottom: 5px;
    color: #555;
}

.form-group input[type="text"],
.form-group textarea {
    width: 100%; /* Ensures inputs take up available width */
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.form-group input[type="text"]:focus,
.form-group textarea:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.3);
}

textarea {
    resize: none; /* Prevents resizing */
    height: 150px; /* Fixed height for the textarea */
}

.submit-button {
    padding: 10px 15px;
    background-color: #000000;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    width: 100%; /* Matches the width of the input fields */
    border: none;
    border-radius: 9px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    align-self: center;
}

.submit-button:hover {
    background-color: #e8e8e8;
    color: black;
}

.message {
    margin-top: 15px;
    padding: 10px;
    border-radius: 4px;
    color: #3a3a3a;
    font-weight: bold;
    text-align: center;
}

.message.success {
    background-color: rgba(83, 153, 255, 0.69);
}

.message.error {
    background-color: #dc3545;

}`, "",{"version":3,"sources":["webpack://./src/pages/WritePage/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB,EAAE,8BAA8B;AACvD;;AAEA;IACI,aAAa;IACb,sBAAsB,EAAE,gCAAgC;IACxD,uBAAuB;IACvB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,WAAW,EAAE,2CAA2C;IACxD,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,YAAY,EAAE,sBAAsB;IACpC,aAAa,EAAE,kCAAkC;AACrD;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW,EAAE,0CAA0C;IACvD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;;AAE7B","sourcesContent":[".qna-form {\n    display: flex;\n    flex-direction: column;\n    margin-top: 40px;\n    width: 70%;\n    margin: 30px auto;\n    align-items: center; /* Centers the form contents */\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column; /* Stack label on top of input */\n    align-items: flex-start;\n    width: 100%;\n    margin-bottom: 15px;\n}\n\n.form-group label {\n    font-size: 16px;\n    font-weight: light;\n    margin-bottom: 5px;\n    color: #555;\n}\n\n.form-group input[type=\"text\"],\n.form-group textarea {\n    width: 100%; /* Ensures inputs take up available width */\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group textarea:focus {\n    border-color: #007bff;\n    outline: none;\n    box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.3);\n}\n\ntextarea {\n    resize: none; /* Prevents resizing */\n    height: 150px; /* Fixed height for the textarea */\n}\n\n.submit-button {\n    padding: 10px 15px;\n    background-color: #000000;\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 400;\n    width: 100%; /* Matches the width of the input fields */\n    border: none;\n    border-radius: 9px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    align-self: center;\n}\n\n.submit-button:hover {\n    background-color: #e8e8e8;\n    color: black;\n}\n\n.message {\n    margin-top: 15px;\n    padding: 10px;\n    border-radius: 4px;\n    color: #3a3a3a;\n    font-weight: bold;\n    text-align: center;\n}\n\n.message.success {\n    background-color: rgba(83, 153, 255, 0.69);\n}\n\n.message.error {\n    background-color: #dc3545;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
